// web-staking-estimator-frontend/src/utils/formatting.js

/**
 * Format a value to a trimmed string
 */
export function fmt(v) {
  return (v ?? "").toString().trim();
}

/**
 * Check if a value has content (non-empty after trimming)
 */
export function has(v) {
  return !!fmt(v);
}

/*
 * Format a 10-digit US phone number as (XXX) XXX-XXXX
 * Strips non-digits, then formats progressively as user types
 * Example: "1234567890" → "(123) 456-7890"
 */
export function formatUSPhone(digits) {
  const d = String(digits || "").replace(/\D/g, "").slice(0, 10);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}
